export const SETDETALLE = 'SETDETALLE';
